import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'

const [tierBenefitsModalState$, setTierBenefitsModalState] = createSignal<{ isOpen: boolean }>()

export { setTierBenefitsModalState }

export const [useTierBenefitsModalState] = bind(tierBenefitsModalState$, { isOpen: false })
